import useUniversityProfile from '../../../hooks/useUniversityProfile';
import useUniversityApprovalStatus from '../../../hooks/useUniversityApprovalStatus';
import useUniversityPaymentStatus from '../../../hooks/useUniversityCheckPaymentStatus';
import UniversityHome from './UniversityHome';
import UniversityDashboardLayout from './dashboard/UniversityDashboardLayout';
const UniversityLayout = () => {
  const profileExists = useUniversityProfile();
  const isUniversityApproved= useUniversityApprovalStatus(profileExists);
  const isUniversityPaymentStatus=useUniversityPaymentStatus(isUniversityApproved)
  // console.log("The const isUniversityPaymentStatus=",isUniversityPaymentStatus)
  // ✅ Call approval hook second, only runs if profile exists

  return (
    <>
   <UniversityDashboardLayout isUniversityPaymentStatus={isUniversityPaymentStatus}/>
    </>
  )
};

export default UniversityLayout;
